export enum FlightTimeType {
  EARLY_MORNING = 'earlyMorning',
  MORNING = 'morning',
  AFTERNOON = 'afternoon',
  EVENING = 'evening',
}
export const FLIGHT_PERIODS = [
  { value: FlightTimeType.EARLY_MORNING, hour: '03:00:00' },
  { value: FlightTimeType.MORNING, hour: '09:00:00' },
  { value: FlightTimeType.AFTERNOON, hour: '15:00:00' },
  { value: FlightTimeType.EVENING, hour: '21:00:00' },
];
